import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import relise from './config'
import svga from 'vue-svga'
import './plugins/element-ui'
import { Message } from 'element-ui'

import './assets/css/base.scss'
import './assets/css/common.scss'

Vue.prototype.$message = Message
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(svga)

relise()
window.addEventListener('resize', function () {
  relise()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
